import { useState } from "react";
import styled from "styled-components";
import Fade from "react-reveal";

// components
import Modal from "../components/organisms/Modal";
import PortraitImage from "../components/molecules/PortraitImage";

// image imports
import one from "../assets/images/portraits/one.jpg";
import two from "../assets/images/portraits/two.jpg";
import three from "../assets/images/portraits/three.jpg";

import four from "../assets/images/portraits/four.jpg";
import five from "../assets/images/portraits/five.jpg";
import six from "../assets/images/portraits/six.jpg";

import seven from "../assets/images/portraits/seven.jpg";
import eight from "../assets/images/portraits/eight.jpg";
import nine from "../assets/images/portraits/nine.jpg";

import ten from "../assets/images/portraits/ten.jpg";
import eleven from "../assets/images/portraits/eleven.jpg";
import twelve from "../assets/images/portraits/twelve.jpg";

import thirteen from "../assets/images/portraits/thirteen.jpg";
import fourteen from "../assets/images/portraits/fourteen.jpg";
import fifteen from "../assets/images/portraits/fifteen.jpg";

import sixteen from "../assets/images/portraits/sixteen.jpg";
import seventeen from "../assets/images/portraits/seventeen.jpg";
import eighteen from "../assets/images/portraits/eighteen.jpg";

import nineteen from "../assets/images/portraits/nineteen.jpg";
import twenty from "../assets/images/portraits/twenty.jpg";
import twentyOne from "../assets/images/portraits/twentyOne.jpg";

import twentyTwo from "../assets/images/portraits/twentyTwo.jpg";
import twentyThree from "../assets/images/portraits/twentyThree.jpg";
import twentyFour from "../assets/images/portraits/twentyFour.jpg";

import twentyFive from "../assets/images/portraits/twentyFive.jpg";
import twentySix from "../assets/images/portraits/twentySix.jpg";
import twentySeven from "../assets/images/portraits/twentySeven.jpg";

import twentyEight from "../assets/images/portraits/twentyEight.jpg";
import twentyNine from "../assets/images/portraits/twentyNine.jpg";
import thirty from "../assets/images/portraits/thirty.jpg";

import thirtyOne from "../assets/images/portraits/thirtyOne.jpg";
import thirtyTwo from "../assets/images/portraits/thirtyTwo.jpg";
import thirtyThree from "../assets/images/portraits/thirtyThree.jpg";

import thirtyFour from "../assets/images/portraits/thirtyFour.jpg";
import thirtyFive from "../assets/images/portraits/thirtyFive.jpg";
import thirtySix from "../assets/images/portraits/thirtySix.jpg";

// style
const StyledPortraitScreen = styled.main`
  min-height: 88vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  section {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    max-width: 1500px;
  }
  h1 {
    opacity: 0.2;
    font-size: 3rem;
  }
`;

const PortraitScreen = () => {
  //! State
  const [openPortraitSet, setOpenPortraitSet] = useState(false);

  //! Functions
  const triggerPortraitSet = () => {
    setOpenPortraitSet((prev) => !prev);
  };

  return (
    <StyledPortraitScreen>
      <h1>Portraits</h1>
      <section>
        <PortraitImage
          imageOne={one}
          imageTwo={two}
          imageThree={three}
          onClick={triggerPortraitSet}
        />
        <PortraitImage
          imageOne={four}
          imageTwo={five}
          imageThree={six}
          onClick={triggerPortraitSet}
        />
        <PortraitImage
          imageOne={seven}
          imageTwo={eight}
          imageThree={nine}
          onClick={triggerPortraitSet}
        />
        <PortraitImage
          imageOne={ten}
          imageTwo={eleven}
          imageThree={twelve}
          onClick={triggerPortraitSet}
        />
        <PortraitImage
          imageOne={thirteen}
          imageTwo={fourteen}
          imageThree={fifteen}
          onClick={triggerPortraitSet}
        />
        <PortraitImage
          imageOne={sixteen}
          imageTwo={seventeen}
          imageThree={eighteen}
          onClick={triggerPortraitSet}
        />
        <PortraitImage
          imageOne={nineteen}
          imageTwo={twenty}
          imageThree={twentyOne}
          onClick={triggerPortraitSet}
        />
        <PortraitImage
          imageOne={twentyTwo}
          imageTwo={twentyThree}
          imageThree={twentyFour}
          onClick={triggerPortraitSet}
        />
        <PortraitImage
          imageOne={twentyFive}
          imageTwo={twentySix}
          imageThree={twentySeven}
          onClick={triggerPortraitSet}
        />
        <PortraitImage
          imageOne={twentyEight}
          imageTwo={twentyNine}
          imageThree={thirty}
          onClick={triggerPortraitSet}
        />
        <PortraitImage
          imageOne={thirtyOne}
          imageTwo={thirtyTwo}
          imageThree={thirtyThree}
          onClick={triggerPortraitSet}
        />
        <PortraitImage
          imageOne={thirtyFour}
          imageTwo={thirtyFive}
          imageThree={thirtySix}
          onClick={triggerPortraitSet}
        />
      </section>
      {/* {openPortraitSet && (
        <Modal onClose={() => setOpenPortraitSet(false)}>
          <Fade top>
            <PortraitImage imageOne={one} imageTwo={two} imageThree={three} />
          </Fade>
        </Modal>
      )} */}
    </StyledPortraitScreen>
  );
};

export default PortraitScreen;
